import { Link } from 'react-router-dom';

export default function CallersInspiredHero() {
  return (
    <section className="bg-[#fdfcf9] border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 text-center py-10 sm:py-24 lg:py-28 lg:min-h-[min(720px,calc(100svh-180px))] flex flex-col items-center justify-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-[1.12] tracking-tight">
          The <span className="text-[#d4a10d]">AI ISA Replacement</span><br />
          Built for Realtors
        </h1>
        <p className="text-lg sm:text-xl text-gray-700 leading-relaxed max-w-2xl mt-5 sm:mt-10">
          Call new leads in 30 seconds. Qualify prospects and book appointments, automatically.
        </p>
        <Link
          to="/book"
          className="w-full sm:w-auto inline-flex items-center justify-center bg-[#d4a10d] hover:bg-[#c3950c] text-gray-950 font-semibold px-10 py-3.5 rounded-md text-lg transition-colors min-h-[52px] mt-6 sm:mt-12"
        >
          Book a Call
        </Link>
      </div>
    </section>
  );
}
